import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

/**
 * Registra o service-worker e ativa a assinatura Web Push.
 * Chamado APÓS o login. Silencioso em caso de falha (best-effort).
 */
export async function ensurePushSubscription() {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return { ok: false, reason: "unsupported" };
    if (typeof Notification === "undefined") return { ok: false, reason: "unsupported" };

    // Registra SW
    const reg = await navigator.serviceWorker.register("/service-worker.js");
    await navigator.serviceWorker.ready;

    // Permissão
    if (Notification.permission === "denied") return { ok: false, reason: "denied" };
    if (Notification.permission !== "granted") {
      const p = await Notification.requestPermission();
      if (p !== "granted") return { ok: false, reason: "denied" };
    }

    // Chave pública VAPID
    const { data } = await api.get("/push/vapid-public-key");
    const key = data?.publicKey;
    if (!key) return { ok: false, reason: "no-key" };

    // Reaproveita assinatura existente se houver
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key),
      });
    }

    // Envia ao backend
    const payload = sub.toJSON();
    await api.post("/push/subscribe", {
      endpoint: payload.endpoint,
      keys: payload.keys || {},
    });
    return { ok: true };
  } catch (e) {
    console.warn("Push subscription falhou:", e?.message || e);
    return { ok: false, reason: "error" };
  }
}

export async function unsubscribePush() {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const { endpoint } = sub.toJSON();
    await sub.unsubscribe();
    await api.post("/push/unsubscribe", { endpoint });
  } catch (e) {
    // Best-effort cleanup on logout — não bloquear o fluxo do usuário
    console.warn("unsubscribePush falhou:", e?.message || e);
  }
}

export async function sendTestNotification() {
  const { data } = await api.post("/push/test");
  return data;
}
